export default function reactInnerHTML(html) {
  return {
    dangerouslySetInnerHTML: { __html: html },
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/react-inner-html/react-inner-html.es.js
// module id = 61
// module chunks = 4